// src/components/Common/GuestRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';
import Loading from './Loading'

const GuestRoute = ({ children }) => {
    const { isAuthenticated, checked } = useAuth();

    if (!checked) {
        return <Loading />
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default GuestRoute;